import React, { HTMLAttributes, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
const { useTranslation } = Hooks;
const { getUrl } = Util;
import store from "store";

import XtTabs from "components/xt/tabs";
import MarketTypeTab from "../../marketTypeTab";
import Fee from "../../_cmpt/fee";
import TradeLimit from "../../_cmpt/tradeLimit";
import TradeMarket from "../../_cmpt/tradeMarket";

import styles from "./index.module.scss";

import { TradeSideEnum } from "store/trade";
import { OptionProps } from "../../index";
import { TradeTypeEnum } from "store/trade";
import EtfBtns from "@/components/pages/trade/_cmpt/form/etfBtns";

interface Props extends OptionProps, HTMLAttributes<HTMLDivElement> {}

const Main: React.FC<Props> = ({ hasFutures, hasEtf, tradeType, setTradeType }) => {
  const t = useTranslation();
  const { name } = store.market;

  const [tradeSide, setTradeSide] = useState(TradeSideEnum.buy);

  const tradeTypeItems = useMemo(() => {
    return [
      {
        key: TradeTypeEnum.limit,
        label: t("trade.limit"),
      },
      {
        key: TradeTypeEnum.market,
        label: t("trade.market"),
      },
    ];
  }, []);

  return (
    <div className={styles.main}>
      <MarketTypeTab />
      <div className={styles.body}>
        <div className={styles.navBtns}>
          <button className={cx("btnTxt", { [styles.navBtns_buy]: tradeSide === TradeSideEnum.buy })} onClick={() => setTradeSide(TradeSideEnum.buy)}>
            {t("trade.buy")}
          </button>
          <button className={cx("btnTxt", { [styles.navBtns_sell]: tradeSide === TradeSideEnum.sell })} onClick={() => setTradeSide(TradeSideEnum.sell)}>
            {t("trade.sell")}
          </button>
        </div>
        <XtTabs className={styles.tabs} activeKey={tradeType} items={tradeTypeItems} onChange={(val) => setTradeType(val as TradeTypeEnum)} />

        {tradeType === TradeTypeEnum.limit && <TradeLimit tradeSide={tradeSide} />}
        {tradeType === TradeTypeEnum.market && <TradeMarket tradeSide={tradeSide} />}

        <div className={styles.links}>
          {/*<a href={getUrl("/rate")} className={cx("linkClear", styles.link)}>*/}
          {/*  {t("trade.fee")}*/}
          {/*</a>*/}
          <Fee className={styles.link} />

          {hasFutures && (
            <>
              <span></span>
              <a href={getUrl("/futures/trade/" + name)} className={cx("linkClear", styles.link)}>
                {t("trade.futures")}
              </a>
            </>
          )}
        </div>

        {hasEtf && <EtfBtns className={styles.etfBtns} />}
      </div>
    </div>
  );
};

export default observer(Main);
